import { type FlowConditionalCondition, FlowConditionalOperation } from 'flow-schema';

import { isDefined } from 'common';

import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField';

export function useConditionLabel(params: { fieldNamePrefix: string }) {
  const { fieldNamePrefix } = params;
  const { value: condition } = useSelectedNodeField<FlowConditionalCondition>(fieldNamePrefix);
  const { value: conditionLabel, setValue: setConditionLabel } = useSelectedNodeField<
    string | undefined
  >(`${fieldNamePrefix}.label`);
  const { value: minValue } = useSelectedNodeField<number | undefined>(
    `${fieldNamePrefix}.minValue`
  );
  const { value: minValueInclusive } = useSelectedNodeField<boolean | undefined>(
    `${fieldNamePrefix}.minValueInclusive`
  );
  const { value: maxValue } = useSelectedNodeField<number | undefined>(
    `${fieldNamePrefix}.maxValue`
  );
  const { value: maxValueInclusive } = useSelectedNodeField<boolean | undefined>(
    `${fieldNamePrefix}.maxValueInclusive`
  );
  return {
    updateConditionLabel: (updatedValues: {
      operation?: FlowConditionalOperation;
      minValue?: number;
      minValueInclusive?: boolean;
      maxValue?: number;
      maxValueInclusive?: boolean;
    }) => {
      const latestOperation = updatedValues.operation ?? condition?.operation;
      const latestMinValue = updatedValues.minValue ?? minValue;
      const latestMinValueInclusive = updatedValues.minValueInclusive ?? minValueInclusive;
      const latestMaxValue = updatedValues.maxValue ?? maxValue;
      const latestMaxValueInclusive = updatedValues.maxValueInclusive ?? maxValueInclusive;

      // If the user has defined a custom label, don't replace it.
      if (
        isDefined(conditionLabel) &&
        !(
          /^\s*$/.exec(conditionLabel) ||
          /^\s*(Not\s+in\s+)?Range\s+(\[|\()[\d\s,]+(\]|\))\s*$/.exec(conditionLabel)
        )
      ) {
        return;
      }
      if (!(isDefined(latestMinValue) && isDefined(latestMaxValue))) {
        return;
      }
      if (
        isDefined(latestOperation) &&
        (latestOperation === FlowConditionalOperation.InRange ||
          latestOperation === FlowConditionalOperation.NotInRange)
      ) {
        let text =
          latestOperation === FlowConditionalOperation.InRange ? 'Range ' : 'Not in Range ';
        text += latestMinValueInclusive ? '[' : '(';
        text += `${latestMinValue}, ${latestMaxValue}`;
        text += latestMaxValueInclusive ? ']' : ')';
        setConditionLabel(text);
      } else {
        setConditionLabel(undefined);
      }
    },
  };
}
